import styled from "styled-components";
import StyledButtonWithIcon from "../../../basic/styledButtonWithIcon/StyledButtonWithIcon";
import DesignConstants from "../../../constants/DesignConstants";

// Grows to fill the remaining viewport height (requires hasFullHeightContent on the header
// wrapper) so the sticky CTA footer is pushed to the bottom and never overlaps the last item.
export const GeneralWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.S};
    flex: 1 0 auto;
`;
export const SelectBookVocabularyWrapper = styled.div`
    width: 100%;
    margin: 0 0 1rem 0;
    min-height: calc(100vh - 310px);
    position: relative;
`;
export const BookHeaderInfo = styled.div`
    display: flex;
    width: 100%;
    justify-content: left;
    align-items: center;
    padding: 0.5rem 0.8rem;
    border-radius: 1rem;
    margin-bottom: 1rem;
    background: white;
`;
// flex-shrink: 0 keeps the cover from being squeezed narrow when a long book name wraps to several
// lines; matches the book cover display in the test-creation flow (selectBookVocabulary).
export const BookImageWrapper = styled.div`
    margin-right: ${DesignConstants.SPACES.S};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;
export const BookNameWrapper = styled.div``;
export const BookName = styled.h4`
    font-weight: normal;
    font-size: 1.25rem;
    margin: 0;
`;

export const ExerciseToSpan = styled.span`
    font-size: 0.9rem;
`;
export const UnitsWrapper = styled.div`
    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        background: white;
        border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
        overflow: hidden;
    }
`;
export const BigButtonWithIcon = styled(StyledButtonWithIcon)`
    min-width: 25% !important;
`;
